function clearTextSelection() {
    var selection = window.getSelection ? window.getSelection() : null;
    if (!selection) return;

    if (selection.removeAllRanges) {
        selection.removeAllRanges();
    } else if (selection.empty) {
        selection.empty();
    }
}

jQuery(function () {
    (function ($) {
        "use strict";

        var Accordion = function (el, options) {
            this.settings = options;
            this.$el = $(el);
            this.$items = this.$el.find("> .accordion-item, > span > .accordion-item");
            this.$titles = this.$items.find("> .accordion-title");

            this.shouldSetMaxHeight = this.$el.closest(".align-height").length;
            this.prependArrow = this.$el.hasClass("accordion-prepend-arrow");
            this.keepItemsOpen = this.$el.hasClass("accordion-keep-open");

            this.init();
        };

        Accordion.prototype = {
            init: function () {
                var self = this;

                self.$items.each(function () {
                    var $item = $(this);
                    var $content = $item.find("> .accordion-content");
                    var $inner = $content.find("> .accordion-content-inner");

                    if (!$item.hasClass("accordion-expanded")) {
                        $item.addClass("accordion-collapsed");
                        $content.css({
                            height: 0,
                            opacity: 0,
                            overflow: "hidden",
                            display: "none"
                        });
                        $inner.css({
                            height: 0,
                            overflow: "hidden",
                            display: "none"
                        });
                        $item.attr("aria-expanded", "false");
                        $inner.removeAttr("tabindex");
                    } else {
                        $content.css({
                            height: "auto",
                            opacity: 1,
                            overflow: "visible",
                            display: "block"
                        });
                        $inner.css({
                            height: "auto",
                            overflow: "visible",
                            display: "block"
                        });
                        $item.attr("aria-expanded", "true");
                        $inner.attr("tabindex", "0");
                    }
                });

                self.$titles.each(function () {
                    var $icon = $(this).find("i"),
                        arrow = '<i class="icon-arrow-down"></i>';

                    if (!$icon.length && !self.$el.hasClass("accordion-no-icon")) {
                        if (self.prependArrow) {
                            $(this)
                                .wrapInner('<span class="accordion-title-content"></span>')
                                .prepend(arrow);
                        } else {
                            $(this).prepend(arrow);
                        }
                    }
                });

                self.bindEvents();

                if (self.shouldSetMaxHeight) {
                    self.$el.addClass("dynamic-height");
                    $(window).on("resize", function () {
                        self.setMaxHeight();
                    });
                    self.setMaxHeight();
                }
            },
            bindEvents: function () {
                var self = this;
                self.$el.off("click.accordionContent keydown.accordionContent");
                self.$el.on(
                    "click.accordionContent keydown.accordionContent",
                    "> .accordion-item > .accordion-content, > .accordion-item > .accordion-content *, " +
                    "> span > .accordion-item > .accordion-content, > span > .accordion-item > .accordion-content *",
                    function (e) {
                        if (e.type === "keydown") {
                            if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") {
                                return;
                            }
                        }
                        var $target = $(e.target);
                        var isInteractive = $target.is("a, button, input, select, textarea");
                        e.stopPropagation();
                        if (!isInteractive) {
                            e.preventDefault();
                        }
                    }
                );

                self.$el.off("click.accordion keydown.accordion");

                self.$el.on(
                    "click.accordion keydown.accordion",
                    "> .accordion-item, > span > .accordion-item",
                    function (e) {
                        var $current = $(this);
                        var $target = $(e.target);
                        var $item = $current.closest(".accordion-item");

                        var isInsideContent = $target.closest(".accordion-content, .accordion-content-inner").length > 0;
                        var isAnchor = $target.closest("a").length > 0;
                        var isDirectItemTarget = $current.hasClass("accordion-item");
                        var isTitleTarget = $current.hasClass("accordion-title") || $target.closest(".accordion-title").length > 0;

                        if (isInsideContent) {
                            return;
                        }

                        if (isAnchor) {
                            return;
                        }

                        if (e.type === "click") {
                            if (!isDirectItemTarget && !isTitleTarget) {
                                return;
                            }
                        }

                        if (e.type === "keydown") {
                            if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") {
                                return;
                            }

                            if (!isDirectItemTarget && !isTitleTarget) {
                                return;
                            }

                            e.preventDefault();
                        }

                        if ($item.hasClass("accordion-inactive") || $item.hasClass("accordion-animating")) {
                            return;
                        }

                        if (
                            $item.attr("id") === "reviewDropdown" &&
                            $target.closest(".accordion-content").length
                        ) {
                            return;
                        }
                        clearTextSelection();

                        if ($item.hasClass("accordion-expanded")) {
                            self.contract($item);
                        } else {
                            self.expand($item);
                        }

                        self.$items
                            .not($item)
                            .removeClass("accordion-expanded")
                            .addClass("accordion-collapsed")
                            .attr("aria-expanded", "false");
                    }
                );
            },
            expand: function ($item) {
                var self = this;
                var $content = $item.find("> .accordion-content");
                var $inner = $content.find("> .accordion-content-inner");
                var $icon = $item.find("> .accordion-title i");

                if (!self.keepItemsOpen) {
                    self.$items.not($item).filter(".accordion-expanded").each(function () {
                        self.contract($(this));
                    });
                }

                $content.stop(true, true);
                $inner.stop(true, true);

                $content.css({
                    display: "block",
                    height: "auto",
                    opacity: 1,
                    overflow: "hidden"
                });

                $inner.css({
                    display: "block",
                    height: "auto",
                    overflow: "visible"
                });

                var targetHeight = $inner.outerHeight(true);

                $content.css({
                    height: 0,
                    opacity: 0,
                    overflow: "hidden"
                });

                $item
                    .addClass("accordion-animating")
                    .removeClass("accordion-collapsed")
                    .addClass("accordion-expanded")
                    .attr("aria-expanded", "true");

                $icon.removeClass("icon-arrow-down").addClass("icon-arrow-up");
                $inner.attr("tabindex", "0");

                $content.animate(
                    {
                        height: targetHeight,
                        opacity: 1
                    },
                    {
                        duration: 300,
                        queue: false,
                        complete: function () {
                            $content.css({
                                height: "auto",
                                overflow: "visible",
                                display: "block",
                                opacity: 1
                            });

                            $inner.css({
                                height: "auto",
                                overflow: "visible",
                                display: "block"
                            });

                            $item.removeClass("accordion-animating");

                            if (self.shouldSetMaxHeight) {
                                self.setMaxHeight();
                            }
                        }
                    }
                );

                $.event.trigger("accordion.changed", {
                    show: $item
                });
            },

            contract: function ($item) {
                var self = this;
                var $content = $item.find("> .accordion-content");
                var $inner = $content.find("> .accordion-content-inner");
                var $icon = $item.find("> .accordion-title i");

                $content.stop(true, true);
                $inner.stop(true, true);

                var currentHeight = $content.outerHeight();

                $item.addClass("accordion-animating");

                $content.css({
                    height: currentHeight,
                    opacity: 1,
                    overflow: "hidden",
                    display: "block"
                });

                $inner.css({
                    height: "auto",
                    overflow: "hidden",
                    display: "block"
                });

                $content.animate(
                    {
                        height: 0,
                        opacity: 0
                    },
                    {
                        duration: 250,
                        queue: false,
                        complete: function () {
                            $content.css({
                                height: 0,
                                opacity: 0,
                                overflow: "hidden",
                                display: "none"
                            });

                            $inner.css({
                                height: 0,
                                overflow: "hidden",
                                display: "none"
                            });

                            $item
                                .removeClass("accordion-expanded")
                                .addClass("accordion-collapsed")
                                .removeClass("accordion-animating");

                            $icon.removeClass("icon-arrow-up").addClass("icon-arrow-down");
                            $item.attr("aria-expanded", "false");
                            $inner.removeAttr("tabindex");

                            if (self.shouldSetMaxHeight) {
                                self.setMaxHeight();
                            }
                        }
                    }
                );
            },

            setMaxHeight: function () {
                var maxHeight = 0;
                var self = this;
                var $currentItem = self.$items.filter(".accordion-expanded");

                $currentItem.removeClass("accordion-expanded");

                self.$items.each(function () {
                    var $item = $(this);
                    $item.addClass("accordion-expanded");

                    if (self.$el.outerHeight(true) > maxHeight) {
                        maxHeight = self.$el.outerHeight(true);
                    }

                    $item.removeClass("accordion-expanded");
                });

                $currentItem.addClass("accordion-expanded");
                self.$el.attr("data-dynamic-height", maxHeight);
            }
        };

        $.fn.accordion = function (options) {
            var args = Array.prototype.slice.call(arguments, 1),
                $this,
                data;

            return this.each(function () {
                $this = $(this);
                data = $this.data("accordion");

                if (!data) {
                    data = new Accordion(this, options);
                    $this.data("accordion", data);
                }

                if (typeof options === "string" && typeof data[options] === "function") {
                    data[options].apply(data, args);
                }
            });
        };

        $.fn.accordion.Constructor = Accordion;

        $(".accordion").accordion();

        $('.tab-link').on('click', function () {
            var targetTab = $(this).attr('data-tab');
            setTimeout(function () {
                $('#' + targetTab + ' .accordion').each(function () {
                    $(this).off("click.accordion keydown.accordion");
                    $(this).removeData('accordion').accordion();
                });
            }, 50);
        });

    })(jQuery);
});